import React from 'react';
import { Navigate } from 'react-router-dom';
import { cookieUtils } from '../utils/cookies';

interface PublicRouteProps {
  children: React.ReactNode;
  isAuthRoute?: boolean;
}

/**
 * PublicRoute component that redirects authenticated users away from auth routes
 * If user has a token and tries to access login/signup, redirect to dashboard
 */
const PublicRoute: React.FC<PublicRouteProps> = ({ children, isAuthRoute = false }) => {
  // Check if access token exists
  const accessToken = cookieUtils.getAccessToken();
  
  // If token exists and this is an auth route, redirect to dashboard
  if (isAuthRoute && accessToken) {
    return <Navigate to="/dashboard" replace />;
  }

  // Render children if no token or not an auth route
  return <>{children}</>;
};

export default PublicRoute;

